export default __webpack_public_path__ + "static/media/education.fa148644.jpg";